import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNotification } from '../redux/notificationSlice';
import { selectAuth } from '../redux/authSlice'

export function SystemMessage() {
  const [message, setMessage] = useState('');
  const [messageId, setMessageId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);

  const onClose = () => {
    setIsVisible(false);

    const dismissedMessages = JSON.parse(localStorage.getItem('dismissedSystemMessages')) || [];

    if (messageId && !dismissedMessages.includes(messageId)) {
      dismissedMessages.push(messageId);
      localStorage.setItem('dismissedSystemMessages', JSON.stringify(dismissedMessages));
    }
  };

  useEffect(() => {
    if (auth.accessToken) {
      const fetchMessage = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_DOMAIN}/system_message/current`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${auth.accessToken}`
            }
        });
          const data = await response.json();

          if (data?.data?.message) {
            const { message, id } = data.data;

            const dismissedMessages = JSON.parse(localStorage.getItem('dismissedSystemMessages')) || [];
            if (!dismissedMessages.includes(id)) {
              setMessage(message);
              setMessageId(id);
              setIsVisible(true);
            }
          }
        } catch (error) {
          dispatch(setNotification({
            type: 'error',
            body: error.response?.data?.message || 'An error occurred',
          }));
        } finally {
          setLoading(false);
        }
      };

      fetchMessage();
    }
  }, [auth]);

  if (!isVisible || loading) return null;

  return (
    <div className="system-message-container">
        <span className="system-message-text">{message}</span>
        <button className="system-message-close-button" onClick={onClose}>X</button>
    </div>
  );
}
